let isRegistered = false;

export function registerGptEventListenersOnce({ onSlotRenderEnded, onSlotVisibilityChanged, onImpressionViewable }) {
  if (typeof window === 'undefined') {
    return;
  }

  if (isRegistered) {
    return;
  }

  isRegistered = true;

  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];

  window.googletag.cmd.push(() => {
    try {
      window.googletag.pubads().addEventListener('slotRenderEnded', event => {
        if (typeof onSlotRenderEnded === 'function') {
          onSlotRenderEnded(event);
        }
      });
      window.googletag.pubads().addEventListener('slotVisibilityChanged', event => {
        if (typeof onSlotVisibilityChanged === 'function') {
          onSlotVisibilityChanged(event);
        }
      });
      window.googletag.pubads().addEventListener('impressionViewable', event => {
        if (typeof onImpressionViewable === 'function') {
          onImpressionViewable(event);
        }
      });
    } catch {
      // ignore
    }
  });
}

export function resetGptEventListenersForTest() {
  isRegistered = false;
}
